import React from 'react';
import escapeHtml from 'escape-html';
import type { IFrameProps } from '@graphcms/rich-text-types';
import { Box } from 'braid-design-system';

export function IFrame({ height, width, url }: Partial<IFrameProps>) {
  return (
    <Box
      marginY={'medium'}
      style={{
        position: 'relative',
        width: '100%',
        // 16:9 Aspect Ratio
        paddingBottom: `56.25%`,
      }}
    >
      <iframe
        src={escapeHtml(url)}
        height={height}
        width={width}
        allow="encrypted-media"
        allowFullScreen={true}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          border: 'none',
        }}
      />
    </Box>
  );
}
